import React, { useEffect, useRef } from 'react';
import { ArrowDown, MapPin, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { personalInfo } from '../data/mock';

const Hero = () => {
  const textRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (textRef.current) {
      observer.observe(textRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToProjects = () => {
    const element = document.querySelector('#projects');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 pt-20">
      <div className="container mx-auto max-w-5xl">
        <div ref={textRef} className="fade-in-up space-y-8">
          <Badge variant="secondary" className="px-4 py-1.5 text-sm font-medium">
            <MapPin className="h-3 w-3 mr-2 inline" />
            {personalInfo.availability}
          </Badge>

          <div className="space-y-4">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight">
              {personalInfo.tagline.split(' ').map((word, index) => (
                <span
                  key={index}
                  className="inline-block"
                  style={{
                    animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`
                  }}
                >
                  {word === 'products' ? (
                    <span className="text-cyan-500">{word}</span>
                  ) : (
                    word
                  )}
                  {' '}
                </span>
              ))}
            </h1>
            
            <p className="text-xl font-mono text-muted-foreground">
              {personalInfo.title} · {personalInfo.location}
            </p>
          </div>

          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl leading-relaxed">
            {personalInfo.description}
          </p>

          <div className="flex flex-wrap gap-4 pt-4">
            <Button
              size="lg"
              onClick={scrollToProjects}
              className="bg-cyan-500 hover:bg-cyan-600 text-white"
            >
              View my work
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={scrollToContact}
            >
              Get in touch
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ArrowDown className="h-6 w-6 text-muted-foreground" />
      </div>
    </section>
  );
};

export default Hero;
